import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../../../../app/hooks";
import {IntegrationForm, IntegrationRequestPartial} from "./createAndUpdate/IntegrationForm";
import {RequestStatus} from "../../../../../../api/apiConfiguration";
import {createIntegrationRequestPropertySelector} from "./selector/IntegrationStoreSelector";
import {
    clearUpdateIntegrationState,
    updateIntegration,
    updateIntegrationRequestSelector,
    updateIntegrationRequestStatusSelector,
    updateUpdateIntegrationRequest
} from "../slice/updateIntegrationSlice";
import {showSuccessToastNotification} from "../../../../../elements/toastNotification/toastNotificationSlice";

interface UpdateIntegrationFormProps {
    configurationData: any
    handleClose: () => void
}

export const UpdateIntegrationForm: React.FC<UpdateIntegrationFormProps> = ({
                                                                                configurationData,
                                                                                handleClose
                                                                            }) => {

    const dispatch = useAppDispatch()
    const updateIntegrationRequestStatus = useAppSelector(updateIntegrationRequestStatusSelector)

    useEffect(() => {
        updateRequest(configurationData)
        return () => {
            dispatch(clearUpdateIntegrationState());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (updateIntegrationRequestStatus === RequestStatus.RESOLVED) {
            handleClose()
            dispatch(showSuccessToastNotification({message: "Integration Updated Successfully"}))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateIntegrationRequestStatus]);

    const updateRequest = (update: IntegrationRequestPartial) => {
        dispatch(updateUpdateIntegrationRequest(update))
    }

    const onSubmit = () => {
        dispatch(updateIntegration())
    }

    return <IntegrationForm
        isUpdateForm={true}
        formTitle={"Update Integration"}
        onClose={handleClose}
        onSubmit={onSubmit}
        updateRequest={updateRequest}
        selectionProvider={createIntegrationRequestPropertySelector(updateIntegrationRequestSelector)}
    />
}
